import styled, { css } from "styled-components";
import { focusWell } from "../../focusWell";
import { inputHighlighting } from "../../../utils/helpers/inputHighlighting";

export const PillButton = styled.button.attrs({
  className: "pill-button"
})(({ theme }) => css`
  ${focusWell({ variant: "pill" })}
  padding: 12px 30px 13px;
  font-size: 20px;
  font-weight: ${theme.fonts.headingWeight};
  color: ${theme.palette.main.black};
  margin: 0;
  box-shadow: inset 2.3px 2px 7px 0 rgba(59, 59, 59, 0.29);

  &[aria-checked="true"] {
    box-shadow: inset -4.8px -6.4px 15px 0 rgba(59, 59, 59, 0.29);
    background-color: ${theme.palette.input.checkbox};
    color: ${theme.palette.main.white};
  }

  ${inputHighlighting()}
  label {
    pointer-events: none;
  }

  &:hover {
    cursor: pointer;
  }
  
  &.combined {
    min-height: 51px;
    min-width: 99px;
    font-size: 16px;
    border: 0.2px solid #00060675;
    
    &:not(:first-of-type) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: 0;
    }
    &:not(:last-of-type) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: 0;
    }
  }
`);